import { toast } from 'react-toastify';
import { reportsApi } from '../../functions/reportsApi.js';
import { reportDetailsActions } from './reportsDetailsReducer';

const {
  setWeeklyPayrollReportData,
  setLoadingWeeklyPayrollReport,
  setPayrollData,
  setLoading,
  setPtoBalances,
  setLoadingPtoBalances,
  setCallbackReportData,
  setLoadingCallbackReport,
  setPtoReportData,
  setLoadingPtoReport,
  setEmployeeList,
  setLoadingEmployeeList,
  setCsvPtoReport,
  setLoadingCsvPtoReport,
  setOvertimeReportData,
  setLoadingOvertimeReport,
  setPayrollReportData,
  setLoadingPayrollReport,
  setCsvOvertimeReport,
  setLoadCsvOvertimeReport,
  setOvertimeListMasterReportData,
  setToggleLoadingOvertimeListMasterReportData,
  setMunisReportData,
  setIsLoadingMunisReportData,
  setMunisReportCsvData,
  setIsLoadingMunisCsvData,
  setSwapShiftsData,
  setIsLoadingSwapShifts,
  setWeeklyPayrollCsvData,
  setIsLoadingWeeklyPayrollCsvData,
  setAdjustHours,
  setIsLoadingAdjustHours,
  setAvailabilityDetail,
  setIsLoadingAvailabilityDetail,
  setAvailabilitySummary,
  setIsLoadingAvailabilitySummary,
  setMiltonReportData,
  setIsLoadingMiltonReportData,
  setCSVMiltonReportData,
  setCSVIsLoadingMiltonReportData,
  setCharltonReportData,
  setLoadingCharltonReport,
  setCSVCharltonReportData,
  setCSVLoadingCharltonReport,
  setWoburnReportData,
  setIsWoburnReportDataLoading,
  setWoburnCSVReportData,
  setLoadingWoburnCSVReport,
  setWoburnOvertimeReportData,
  setLoadingWoburnOvertimeReport,
  setCSVWoburnOvertimeReportData,
  setLoadingCSVWoburnOvertimeReport,
  setWoburnReassignmentReportData,
  setLoadingWoburnReassignmentReportData,
  setCSVWoburnReassignmentReport,
  setIsLoadingCSVWoburnReassignmentReport,
  setWoburnPTOReportData,
  setLoadingWoburnPTOReport,
  setWoburnPtoCSVReportData,
  setLoadingWoburnPtoCSVReport,
  setWoburnMunisPtoReportData,
  setLoadingWoburnMunisPtoReport,
  setWoburnMunisPtoCSVReportData,
  setLoadingWoburnMunisPtoCSVReport,
  setWoburnMunisOvertimeReportData,
  setLoadingWoburnMunisOvertimeReport,
  setWoburnMunisOvertimeCSVReportData,
  setLoadingWoburnMunisOvertimeCSVReport,
  setAvailableReports,
  setIsAvailableReportsLoading,
  setPtoOptionsList,
  setIsLoadingPtoOptionsList,
} = reportDetailsActions;
const getResponseData = (response) => {
  return response.data?.data ?? response.data;
};

function createThunkAction(apiCall, setDataAction, setLoadingAction, handler) {
  return (params) => async (dispatch) => {
    try {
      dispatch(setLoadingAction(true));
      const response = await apiCall(params);

      if (response.status === 200) {
        const data = handler?.(response) || getResponseData(response);

        dispatch(setDataAction(data));
      } else {
        throw response;
      }
    } catch (err) {
      console.log(err)
      if('errors' in err) {
        toast.error(Object.values(err).join(' '));
      } else {
        toast.error(err.message);
      }
      console.error(err);
    } finally {
      dispatch(setLoadingAction(false));
    }
  };
}

const csvHandler = (response) => {
  const contentDisposition = response.headers['content-disposition'];
  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
    if (filenameMatch) {
      const filename = filenameMatch[1];
      return {
        data: getResponseData(response),
        filename,
      };
    }
  }
  return getResponseData(response);
};

export const reportDetailsThunkActions = {
  getWoburnMunisPtoReport: createThunkAction(
    reportsApi.getWoburnMunisPtoData,
    setWoburnMunisPtoReportData,
    setLoadingWoburnMunisPtoReport
  ),
  getWoburnMunisPtoCSVReportCsvData: createThunkAction(
    reportsApi.getWoburnMunisPtoData,
    setWoburnMunisPtoCSVReportData,
    setLoadingWoburnMunisPtoCSVReport,
    csvHandler
  ),
  getWeeklyPayrollReport: createThunkAction(
    reportsApi.getWeeklyPayrollReport,
    setWeeklyPayrollReportData,
    setLoadingWeeklyPayrollReport
  ),
  getWeeklyPayrollReportCsvData: createThunkAction(
    reportsApi.getWeeklyPayrollReport,
    setWeeklyPayrollCsvData,
    setIsLoadingWeeklyPayrollCsvData,
    csvHandler
  ),
  getPayrollData: createThunkAction(
    reportsApi.getPayrollData,
    setPayrollData,
    setLoading
  ),

  getPtoBalances: createThunkAction(
    reportsApi.getPtoBalances,
    setPtoBalances,
    setLoadingPtoBalances
  ),

  getCallbackReport: createThunkAction(
    reportsApi.getCallbackReport,
    setCallbackReportData,
    setLoadingCallbackReport
  ),

  getPtoReport: createThunkAction(
    reportsApi.getPtoReport,
    setPtoReportData,
    setLoadingPtoReport
  ),
  getEmployeeList: createThunkAction(
    reportsApi.getEmployeeList,
    setEmployeeList,
    setLoadingEmployeeList
  ),
  getCsvReport: createThunkAction(
    reportsApi.getPtoReport,
    setCsvPtoReport,
    setLoadingCsvPtoReport,
    csvHandler
  ),
  getOvertimeReport: createThunkAction(
    reportsApi.getOvertimeReportData,
    setOvertimeReportData,
    setLoadingOvertimeReport
  ),
  getOvertimeListMasterReport: createThunkAction(
    reportsApi.getOvertimeListMasterReportData,
    setOvertimeListMasterReportData,
    setToggleLoadingOvertimeListMasterReportData
  ),
  getPayrollReport: createThunkAction(
    reportsApi.getPayrollReportData,
    setPayrollReportData,
    setLoadingPayrollReport
  ),
  getCsvOvertimeReport: createThunkAction(
    reportsApi.getOvertimeReportData,
    setCsvOvertimeReport,
    setLoadCsvOvertimeReport,
    csvHandler
  ),
  getMunisReportData: createThunkAction(
    reportsApi.getMunisReportData,
    setMunisReportData,
    setIsLoadingMunisReportData
  ),
  getMunisReportCsvData: createThunkAction(
    reportsApi.getMunisReportData,
    setMunisReportCsvData,
    setIsLoadingMunisCsvData,
    csvHandler
  ),
  getSwapShiftsReportData: createThunkAction(
    reportsApi.getSwapShifts,
    setSwapShiftsData,
    setIsLoadingSwapShifts
  ),
  getAdjustHoursReportData: createThunkAction(
    reportsApi.getAdjustHours,
    setAdjustHours,
    setIsLoadingAdjustHours
  ),
  getAvailabilityDetailReportData: createThunkAction(
    reportsApi.getAvailabilityDetail,
    setAvailabilityDetail,
    setIsLoadingAvailabilityDetail
  ),
  getAvailabilitySummaryReportData: createThunkAction(
    reportsApi.getAvailabilitySummary,
    setAvailabilitySummary,
    setIsLoadingAvailabilitySummary
  ),
  getMiltonReportData: createThunkAction(
    reportsApi.getMiltonReportData,
    setMiltonReportData,
    setIsLoadingMiltonReportData
  ),
  getCSVMiltonReportData: createThunkAction(
    reportsApi.getMiltonReportData,
    setCSVMiltonReportData,
    setCSVIsLoadingMiltonReportData,
    csvHandler
  ),
  getCharltonReportData: createThunkAction(
    reportsApi.getCharltonReportData,
    setCharltonReportData,
    setLoadingCharltonReport
  ),
  getCSVCharltonReportData: createThunkAction(
    reportsApi.getCharltonReportData,
    setCSVCharltonReportData,
    setCSVLoadingCharltonReport,
    csvHandler
  ),
  getWoburnReportData: createThunkAction(
    reportsApi.getWoburnReportData,
    setWoburnReportData,
    setIsWoburnReportDataLoading
  ),
  getWoburnCSVReportData: createThunkAction(
    reportsApi.getWoburnReportData,
    setWoburnCSVReportData,
    setLoadingWoburnCSVReport,
    csvHandler
  ),
  getWoburnOvertimeReportData: createThunkAction(
    reportsApi.getWoburnOvertimeReportData,
    setWoburnOvertimeReportData,
    setLoadingWoburnOvertimeReport
  ),
  getCSVWoburnOvertimeReportData: createThunkAction(
    reportsApi.getWoburnOvertimeReportData,
    setCSVWoburnOvertimeReportData,
    setLoadingCSVWoburnOvertimeReport,
    csvHandler
  ),
  getWoburnReassignmentReportData: createThunkAction(
    reportsApi.getWoburnReassignmentReportData,
    setWoburnReassignmentReportData,
    setLoadingWoburnReassignmentReportData
  ),
  getCSVWoburnReassignmentReport: createThunkAction(
    reportsApi.getWoburnReassignmentReportData,
    setCSVWoburnReassignmentReport,
    setIsLoadingCSVWoburnReassignmentReport,
    csvHandler
  ),
  getWoburnPTOReportData: createThunkAction(
    reportsApi.getWoburnPTOReportData,
    setWoburnPTOReportData,
    setLoadingWoburnPTOReport
  ),
  getCSVWoburnPTOReportData: createThunkAction(
    reportsApi.getWoburnPTOReportData,
    setWoburnPtoCSVReportData,
    setLoadingWoburnPtoCSVReport,
    csvHandler
  ),
  getWoburnMunisOvertimeReportData: createThunkAction(
    reportsApi.getWoburnMunisOvertimeReportData,
    setWoburnMunisOvertimeReportData,
    setLoadingWoburnMunisOvertimeReport
  ),
  getCSVWoburnMunisOvertimeReportData: createThunkAction(
    reportsApi.getWoburnMunisOvertimeReportData,
    setWoburnMunisOvertimeCSVReportData,
    setLoadingWoburnMunisOvertimeCSVReport,
    csvHandler
  ),
  getAvailableReports: createThunkAction(
    reportsApi.getAvailableReportsList,
    setAvailableReports,
    setIsAvailableReportsLoading
  ),
  getPtoOptionListData: createThunkAction(
    reportsApi.getPtoOptionsList,
    setPtoOptionsList,
    setIsLoadingPtoOptionsList
  ),
};
